let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("247gI")).then(() => parcelRequire('lTJ4V'));